import React, { useContext } from 'react';
import { Nav, NavItem } from '@scholastic/volume-react';

import { Link } from 'react-router-dom';

import { ActionType, StoreContext } from '../../state/store';

import './Nav.scss';

export const StatsNav = () => {
  const { state, dispatch } = useContext(StoreContext);
  const customer = state.customerInfo;
  return (
    <Nav id="mainNav" tag="ul">
      <NavItem id="navItemHome" active={window.location.pathname === '/home'}>
        <Link
          to="/home"
          onClick={() => {
            dispatch({ type: ActionType.SET_REPORT_INFO, data: undefined });
            dispatch({ type: ActionType.SET_INDIVIDUAL_SITE_PAGE_INFO, data: undefined });
          }}
        >
          <span className="stats-nav__text-holder">Standard</span>
        </Link>
      </NavItem>
      <NavItem id="navItemCounterReports" active={window.location.pathname === '/counter-reports'}>
        <Link to="/counter-reports">
          <span className="stats-nav__text-holder">Counter</span>
        </Link>
      </NavItem>
      <NavItem id="navItemMonthlyReports" active={window.location.pathname === '/monthly-reports'}>
        <Link to="/monthly-reports">
          <span className="stats-nav__text-holder">Monthly</span>
        </Link>
      </NavItem>
      {customer?.result.hasmidtier && (
        <NavItem active={window.location.pathname === '/group-level-reports'}>
          <Link to="/group-level-reports">
            <span className="stats-nav__text-holder"> Group Level </span>
          </Link>
        </NavItem>
      )}
      <NavItem id="navItemHelp" active={window.location.pathname === '/stats-help'}>
        <Link to="/stats-help">
          <span className="stats-nav__text-holder"> Help with Stats </span>
        </Link>
      </NavItem>
    </Nav>
  );
};

export default StatsNav;
